import { useEffect, useLayoutEffect } from 'react';

// Ember pages render in Node before the browser hydrates them. Layout effects
// are still required in the browser, but React warns if they are used during
// renderToString, where no layout exists.
export const useBrowserLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;
